module.exports = {"attributes":{"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.5668 15.6192C6.36972 15.8264 6.03934 15.8264 5.84226 15.6192L5.66121 15.4289C5.47757 15.2358 5.47757 14.9327 5.66121 14.7396L10.9922 9.13559C11.0289 9.09698 11.0289 9.03635 10.9922 8.99774L5.66121 3.39372C5.47757 3.20067 5.47757 2.89753 5.66121 2.70448L5.84226 2.51416C6.03934 2.30698 6.36972 2.30698 6.5668 2.51416L12.4722 8.72205C12.6559 8.9151 12.6559 9.21824 12.4722 9.41128L6.5668 15.6192Z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
